import { ImportWizardQuarantinedDrugListComponent } from './../import-wizard-quarantined-drug-list/import-wizard-quarantined-drug-list.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Drug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { routePaths } from 'src/app/config/app-constants';
import { ImportWizardDrugDetailsComponent } from '../import-wizard-drug-details/import-wizard-drug-details.component';
import { OpenEditWizardService } from '../../services/open-edit-wizard.service';
@Component({
    selector: 'app-quarantined-drug-list',
    templateUrl: './quarantined-drug-list.component.html',
    styleUrls: ['./quarantined-drug-list.component.scss'],
    standalone: false
})
export class QuarantinedDrugListComponent implements OnInit, OnChanges {
  displayedColumns = ['name', 'ndc', 'countryCode', 'qReason', 'source', 'system', 'strength', 'manufacturer', 'priority', 'modifiedBy' ,'requestor', 'age','action'];
  selectedRow:any;
  @Input() dataSourceId: number;
  @Input() searchText: string;
  @Input() permanentQuarantine:boolean = false;
  @Input() countryId: number;
  @Input() qReasonId: number;
  @Output() countUpdated: EventEmitter<number> = new EventEmitter<number>();
  @Input() selectedSearchCriteria: any;
  @Input() modifiedBy: string = null;
  dataSource= new MatTableDataSource<Drug>();
     //#region Pagination properties
     totalRows: number = 0;
     currentPage: number = 1;
     pageSize: number = 5;
     pageSizeOptions: number[] = [5, 10, 20, 40, 50];
     //#endregion
  private hasInitialized: boolean = false;
  constructor(
    private rpoService: RpoToolService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,
    private openEditWizardService: OpenEditWizardService) { }

  ngOnInit(): void {
   this.getDrugData();
   this.hasInitialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.hasInitialized) {
      return;
    }

    const shouldRefresh =
      !!changes['dataSourceId'] ||
      !!changes['searchText'] ||
      !!changes['countryId'] ||
      !!changes['qReasonId'] ||
      !!changes['selectedSearchCriteria'] ||
      !!changes['modifiedBy'] ||
      !!changes['permanentQuarantine'];

    if (shouldRefresh) {
      this.currentPage = 1;
      this.getDrugData();
    }
  }

  handleInputChange(dataSourceId:number,searchText:any, countryId:number, permanentQuarantine:boolean = false){
    this.dataSourceId=dataSourceId;
    this.searchText = searchText;
    this.countryId = countryId;
    this.permanentQuarantine = permanentQuarantine;
    if(this.searchText.length>0 || this.countryId>=0){
       // this.getDrugData();
    }


}

  getDrugData(){
    this.ngxLoader.start();
    this.rpoService.getQuarantinedDrugatav1(
      this.dataSourceId,
      this.searchText,
      this.permanentQuarantine,
      this.countryId,
      this.qReasonId,
      this.currentPage,
      this.pageSize,
      this.selectedSearchCriteria,
      this.modifiedBy
    ).subscribe((result)=>{
     this.dataSource.data = result.data.drugs
     this.currentPage = result.data.currentPage
     this.totalRows = result.data.totalRows
     this.countUpdated.emit(this.totalRows);
     this.ngxLoader.stop();

    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop();
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );

    })
  }


  openImportWizardQuanrantinedDrug() {

    const dialogRef = this.dialog.open(ImportWizardQuarantinedDrugListComponent, {
    backdropClass: ['lgDialog'],
    disableClose: true,
    data:{
      dataSourceId:this.dataSourceId,
      searchText: this.searchText,
      countryId:this.countryId,
      qReasonId: this.qReasonId,
      permanentQuarantine:this.permanentQuarantine
    }
    });

  }

  openDrugDetailsImportWizard(drugId:string, dataSourceId:number) {
    
    this.openEditWizardService.openDrugDetailsImportWizard(drugId,dataSourceId,'');
  }
}
